import { Dialog, DialogActions, DialogBody, DialogTitle, ShowProps } from '@/components/base/dialog'
import { Divider } from '@/components/base/divider'
import { Text } from '@/components/base/text'
import { useEffect, useState } from 'react'
import { DocumentQuery } from './__generated__/show_query'
import { DocumentQuery as Query } from './show_query'
import { useQuery } from '@apollo/client'
import { Inline as Loading } from '@/components/loading'
import { Inline as Error } from '@/components/error'
import { Button } from '../base/button'
import { DeleteDialog } from '../delete_dialog'
import { Mutation as DeleteMutation } from './delete_mutation'
import { Query as TableQuery } from './table_query'

type Document = DocumentQuery['documents']['nodes'][0]

export const ShowDialog = ({ id, open, setOpen }: ShowProps) => {
  const [document, setDocument] = useState<Document | null>(null)
  const [openDelete, setOpenDelete] = useState(false)
  const { data, loading, error } = useQuery<DocumentQuery>(Query, { variables: { filters: { idEq: id } } })

  useEffect(() => {
    if (!data || !id) { return }

    setDocument(data.documents.nodes[0])
  }, [id, data])

  const onDelete = () => {
    setOpenDelete(true)
  }

  const onDeleteSuccess = () => {
    setOpenDelete(false)
    setOpen(false)
  }

  return (
    <>
      <Dialog open={open} size="7xl" onClose={() => setOpen(false)}>
        <DialogTitle>
          { loading || !document
            ? <Loading />
            : <div className="flex flex-row justify-between">
              <div>
                <span className="flex flex-row gap-4 items-center">
                  { document.name }
                </span>
              </div>
            </div> }
        </DialogTitle>
        <DialogBody>
          { error && <Error message={error.message} />}
          { document && <div className="flex flex-col gap-4">
            <div className="grid grid-cols-4 items-center align-center" />
            <Divider />
            <div className="flex flex-col">
              {
                document.url
                  ? <embed className="h-[60vh]" src={document.url} type="application/pdf" />
                  : <Text>Processing...</Text>
              }
            </div>
          </div> }
        </DialogBody>
        <DialogActions>
          { document && <Button color="red" onClick={onDelete}>Delete</Button> }
        </DialogActions>
      </Dialog>
      { document && <DeleteDialog
        id={document.id}
        mutation={DeleteMutation}
        open={openDelete}
        refetchQueries={[TableQuery]}
        setOpen={setOpenDelete}
        onSuccess={onDeleteSuccess}
      /> }
    </>
  )
}
